export default __webpack_public_path__ + "static/media/vcfo-logo-cms.571ca50c.png";